export default "__VITE_ASSET__BI2GlyAW__"